<!-- Accordion  -->
@if (requestDetailsResponse()) {
  <div
    id="request-details"
    [class]="`h-[calc(100vh-17.5rem)] overflow-y-auto pe-md mt-lg ${!isRequestHeaderUiEnhancementEnabled() && 'h-[calc(100vh-9.5rem)]!'}`">
    @let schedule = requestDetailsResponse()?.data?.schedule;
    @if (isScheduleOnceOnlyEnabled() && schedule) {
      @let requestName = requestDetailsResponse()?.data?.name;
      @let description = schedule.description;
      @let creatorName = schedule.created_by.name;
      @let alertDescription =
        'request_view_details_schedule_alert_description'
          | transloco
            : {
                date: schedule?.updated_at | date: 'dd-MMM-yyyy hh:mm a',
                requestName,
                creatorName,
              };
      @let modalTitle =
        'request_view_details_schedule_description_modal_title' | transloco;
      <div class="mb-lg">
        <lib-alert-inline
          [alertData]="{
            status: 'primary',
            title: 'general_system_autotrigger_user_label' | transloco,
            description: alertDescription,
          }"
          [hasContent]="true"
          [hasCloseIcon]="false"
          [hasIcon]="true"
          [iconTemplate]="clockIconTemplate">
          @if (description) {
            <button
              type="button"
              class="text-primary-800 font-medium text-sm pt-md"
              (click)="
                modalService.modalContent.set({
                  isOpen: true,
                  hasCloseIcon: true,
                  title: modalTitle,
                  customizeContent: descriptionModalTemplate,
                  width: '45',
                })
              ">
              {{
                'request_view_details_schedule_see_description_button_label'
                  | transloco
              }}
            </button>
          }
        </lib-alert-inline>
      </div>
    } @else if (isAutoTriggerAlertShown()) {
      <div class="mb-lg">
        <lib-alert-inline
          [alertData]="{
            status: 'primary',
            title: 'general_system_autotrigger_user_label' | transloco,
            description: `${(requestDetailsResponse()?.data?.created_at ?? '' | date: 'dd-MMM-yyyy hh:mm a')}: 
        ${('request_view_details_creator_deleted_alert_description' | transloco)}`,
          }"
          [hasContent]="true"
          [hasCloseIcon]="false"
          [hasIcon]="true" />
      </div>
    }

    @for (
      position of requestDetailsResponse()?.data?.positions ?? [];
      track position;
      let isFirst = $first
    ) {
      <lib-accordion-2
        [title]="position.position_name"
        [badgeTemplate]="position_status"
        [accordionDetailsClass]="'mb-lg ' + (!isFirst ? 'mt-lg' : '')"
        [disable]="
          position.state?.value === stepStatusEnum.NOT_STARTED ||
          (position.state?.value === stepStatusEnum.SKIPPED &&
            position.steps.length === 1)
        "
        [hasColoredBackground]="true"
        [hideArrow]="
          position.state?.value === stepStatusEnum.NOT_STARTED ||
          (position.state?.value === stepStatusEnum.SKIPPED &&
            position.steps.length === 1)
        ">
        <ng-template #position_status>
          <lib-badge
            [label]="position.state?.label ?? ''"
            class="flex"
            [badgeClass]="
              'py-xs px-md border-none text-sm font-medium ' +
              (position.state?.value ?? '' | stepStatus)
            " />
        </ng-template>

        <div class="pb-xs">
          @if (position.steps) {
            @for (
              step of position.steps;
              track step;
              let i = $index ,last = $last
            ) {
              <div class="w-full py-md border-b border-neutral-200">
                <div class="mx-[2.25rem]">
                  @if (position.steps.length > 1) {
                    <div class="flex justify-between items-center py-sm">
                      <p class="text-sm font-medium">
                        {{ step.name }}
                      </p>

                      <lib-badge
                        [label]="
                          step.details.state?.label ||
                          ('step_status_' +
                            (step.details.state?.value ||
                              stepStatusEnum.NO_ACTION) | transloco)
                        "
                        [badgeClass]="
                          'px-sm border-none text-sm font-medium  ' +
                          (step.details.state?.value || stepStatusEnum.NO_ACTION
                            | parallelStepStatus)
                        " />
                    </div>
                  }

                  @for (assignee of step.details.assignees; track assignee) {
                    @if (step.details.assignees?.length === 1) {
                      <div
                        class="flex justify-between items-center pt-x-sm mb-x-sm">
                        <div class="flex items-center gap-x-sm">
                          @let assigneeData = assignee.data;

                          <lib-request-creator
                            [creator]="assigneeData"
                            [isItemCenter]="
                              !step.escalation || !step.escalation.sent_at
                            "
                            [size]="'sm'" />

                          @if (assignee?.assignee_role) {
                            <span
                              class="text-sm font-semibold text-neutral-900">
                              ({{ assignee.assignee_role }})
                            </span>
                          }

                          @let state = assigneeData?.state;
                          @let isDeleted =
                            assigneeData?.deleted_at ||
                            assigneeData?.state?.value === Status.DELETED;
                          @let isInactive = state?.value === Status.INACTIVE;

                          @if (isInactive || isDeleted) {
                            @let mappedState =
                              isDeleted
                                ? DELETE_ASSIGNEE_STATUS
                                : (state ?? null);

                            <lib-badge
                              [label]="mappedState?.label || ''"
                              [badgeClass]="'py-xs px-md border-none text-xs font-medium bg-destructive-50 text-destructive-700'" />
                          }
                        </div>
                      </div>
                    }
                  }

                  @if (
                    step.details &&
                    step.details.assignees &&
                    step.details.assignees.length > 1
                  ) {
                    <div class="my-sm">
                      <lib-side-menu-assignee-dropdown-view
                        [userCount]="getAssigneesLength(step)"
                        [userTableList]="getMappedAssignees(step)"
                        [userDropdownList]="getMappedAssignees(step)"
                        [totalDropdownCount]="getAssigneesLength(step)"
                        [assigneeType]="getAssigneeType(step)"
                        [headerListLabel]="
                          'dropdown_header_list_assignees_label' | transloco
                        "
                        [searchLabel]="
                          'dropdown_search_find_assignees_label' | transloco
                        "
                        [searchPlaceholder]="
                          'search_by_name_placeholder' | transloco
                        "
                        [noSearchResultLabel]="
                          'no_search_result_label' | transloco
                        "
                        [enableLocalSearch]="true"
                        [imgDimensions]="{ width: 24, height: 24 }"
                        [containerRef]="'request-details'"
                        [displayMode]="'underlined-text'"
                        [showCloseButton]="true" />
                    </div>
                  }

                  <!-- ETA -->
                  @if (
                    step.details.state?.value === stepStatusEnum.INPROGRESS
                  ) {
                    <div
                      class="flex items-center font-medium mb-xs mx-[2.625rem]">
                      <span
                        class="text-xs"
                        libSla
                        [isTable]="false"
                        [clockTemplate]="clockTemplate"
                        [sla]="step.details.due_date">
                        {{
                          'request_view_details_off_canvas_eta_label'
                            | transloco
                        }}
                        <span dir="ltr" class="font-medium ms-xs">
                          {{
                            step.details.due_date | date: 'dd-MMM-yyyy hh:mm a'
                          }}
                        </span>
                      </span>
                    </div>
                  }

                  @for (log of step?.logs; track log) {
                    <div class="flex justify-between items-center">
                      <div
                        class="flex gap-md w-full"
                        [class.items-center]="
                          !step.escalation || !step.escalation.sent_at
                        ">
                        <div class="flex flex-col w-full">
                          <div class="flex items-center">
                            <!-- Taken By -->
                            @if (
                              log?.taken_by &&
                              log?.type !== logTypeEnum.USER &&
                              step.details.state?.value !==
                                stepStatusEnum.INPROGRESS
                            ) {
                              <lib-vertical-line-icon
                                [iconClass]="'text-neutral-200'" />

                              <div class="text-xs text-neutral-500">
                                {{ log?.taken_by.name }}
                              </div>
                            }
                          </div>

                          @if (
                            log?.user ||
                            (!log?.user &&
                              systemGeneratedActionTypes.includes(log.type!))
                          ) {
                            <div
                              class="flex items-start gap-x-x-sm mt-sm mx-[2.8125rem]">
                              @if (log?.replacable) {
                                <lib-bypass-icon
                                  [iconClass]="'flex-shrink-0 size-4 text-destructive-500 '" />
                              } @else if (
                                log?.type === logTypeEnum.TAKE_ACTION_ON_FLOW
                              ) {
                                @if (log.action?.value === 'hold') {
                                  <lib-hold-icon
                                    [iconClass]="'flex-shrink-0 size-4 text-warning-500 '" />
                                } @else if (log.action?.value === 'resume') {
                                  <lib-play-icon
                                    [iconClass]="'flex-shrink-0 size-4 text-primary-500 '" />
                                }
                              } @else {
                                @if (
                                  log?.created_at &&
                                  step.details.due_date &&
                                  log.created_at! > step.details.due_date
                                ) {
                                  <lib-clock-icon
                                    [iconClass]="'flex-shrink-0 size-4 text-destructive-500 '" />
                                } @else {
                                  <lib-clock-icon
                                    [iconClass]="'flex-shrink-0 size-4 text-neutral-500 '" />
                                }
                              }

                              <div class="text-xs text-neutral-700 flex-1">
                                <span dir="ltr">
                                  {{
                                    log?.created_at
                                      | date: 'dd-MMM-yyyy hh:mm a'
                                  }}:
                                </span>

                                @if (log?.replacable) {
                                  <span class="font-semibold">
                                    @if (log?.taken_as?.label) {
                                      {{ log?.taken_as.label }}
                                    } @else {
                                      {{
                                        'request_view_details_off_canvas_manager_label'
                                          | transloco
                                      }}
                                    }
                                  </span>

                                  ({{
                                    log?.user?.name ??
                                      ('general_system_autotrigger_user_label'
                                        | transloco)
                                  }})

                                  <span
                                    class="font-medium text-destructive-500">
                                    {{
                                      'request_view_details_off_canvas_bypassed_assignee_label'
                                        | transloco
                                    }}
                                  </span>

                                  <span class="font-medium">
                                    {{
                                      'request_view_details_off_canvas_and_took_action_label'
                                        | transloco
                                    }}
                                  </span>

                                  <span class="font-medium">
                                    {{ log?.action?.label | titlecase }}
                                  </span>

                                  @if (log?.effected?.name) {
                                    <span class="font-medium">
                                      ({{ log?.effected.name }})
                                    </span>
                                  }

                                  <span class="font-medium">
                                    {{
                                      'request_view_details_off_canvas_on_behalf_of_label'
                                        | transloco
                                    }}
                                  </span>

                                  ({{ log?.replacable.name }})
                                } @else {
                                  ({{
                                    log?.user?.name ??
                                      ('general_system_autotrigger_user_label'
                                        | transloco)
                                  }})

                                  @if (
                                    log?.type === logTypeEnum.TAKE_ACTION ||
                                    log?.type ===
                                      logTypeEnum.TAKE_ACTION_ON_FLOW
                                  ) {
                                    {{
                                      'request_view_details_off_canvas_take_action_label'
                                        | transloco
                                    }}
                                  } @else if (
                                    log?.type === logTypeEnum.COMMENT
                                  ) {
                                    {{
                                      'request_view_details_off_canvas_comment_label'
                                        | transloco
                                    }}
                                  }

                                  <span
                                    class="font-medium"
                                    [class.text-warning-500]="
                                      log?.action?.value === 'hold'
                                    "
                                    [class.text-primary-500]="
                                      log?.action?.value === 'resume'
                                    ">
                                    {{ log?.action?.label | titlecase }}
                                  </span>

                                  @if (log?.effected?.name) {
                                    ({{ log?.effected.name }})
                                  }
                                }
                              </div>
                            </div>
                          }

                          @if (log?.type === logTypeEnum.ESCALATION) {
                            <div
                              class="flex items-center gap-x-sm mt-sm mx-[2.625rem] px-[.1875rem]">
                              <lib-warning-icon
                                [iconClass]="'flex-shrink-0 size-4 text-destructive-500'" />

                              <div class="text-xs text-neutral-700" dir="ltr">
                                <span dir="ltr">
                                  {{
                                    log?.created_at
                                      | date: 'dd-MMM-yyyy hh:mm a'
                                  }}:
                                </span>

                                {{
                                  'request_view_details_off_canvas_system_sla_action_label'
                                    | transloco
                                }}

                                <span
                                  class="text-xs text-neutral-700 font-medium">
                                  {{ log?.action?.label }}
                                </span>

                                @if (log?.taken_as?.value === isManager) {
                                  <span>({{ log?.taken_as.label }})</span>
                                } @else {
                                  <span>({{ log?.effected?.name }})</span>
                                }
                              </div>
                            </div>
                          }

                          @if (log.comment || log.reason) {
                            <div
                              class="flex flex-col ms-8xl my-sm px-lg py-sm bg-neutral-50 border border-neutral-200 rounded-sm">
                              @if (log.reason) {
                                <p
                                  class="mb-xs text-neutral-900 font-medium text-xs">
                                  <span class="font-semibold">{{
                                    'request_view_details_reason_label'
                                      | transloco
                                  }}</span
                                  >:
                                  {{ log.reason }}
                                </p>
                              }

                              @if (log.comment) {
                                <div
                                  class="text-neutral-500 font-medium text-xs2">
                                  <span class="font-semibold">
                                    {{
                                      'request_view_details_comment_label'
                                        | transloco
                                    }}:
                                  </span>
                                  <div
                                    class="rich-text-content"
                                    [innerHTML]="
                                      log.comment | sanitizeHtml
                                    "></div>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          }
        </div>
      </lib-accordion-2>
    }
  </div>
}

<ng-template #clockTemplate let-isOverdue>
  <lib-clock-icon
    [iconClass]="
      'size-4 ' + (isOverdue ? 'text-destructive-500' : 'text-neutral-500')
    " />
</ng-template>

<ng-template #clockIconTemplate>
  <lib-timer-icon [iconClass]="'size-6'" />
</ng-template>

<ng-template #descriptionModalTemplate>
  @let description = requestDetailsResponse()?.data?.schedule?.description;
  @if (description) {
    <div
      class="rich-text-content overflow-y-auto max-h-[60vh] text-sm text-neutral-700"
      [innerHTML]="description | sanitizeHtml"></div>
  }
</ng-template>
